import { IListResponse, XHRInstance } from "@sembark-travel/xhr"
import type { THotelChannelManager } from "../Hotels"
import type { TOtaMealPlan } from "../HotelOtaMealPlans"
import type { TOtaRoomType } from "../HotelOtaRoomTypes"

export type TOtaRatePlan = {
	id: number
	name: string
	// Null for a hotel with no channel manager
	channel_manager: THotelChannelManager | null
	// The next four are null together, on the single "Standard" plan of a hotel with no channel manager
	ota_room_type_id: number | null
	ota_meal_plan_id: number | null
	ota_room_type: TOtaRoomType | null
	ota_meal_plan: TOtaMealPlan | null
}

export function hotelOtaRatePlansXHR(xhr: XHRInstance) {
	return {
		async getOtaRatePlans(
			hotelId: string | number,
			params?: Record<string, unknown>
		): Promise<IListResponse<TOtaRatePlan>> {
			return xhr
				.get(`/hotels/${hotelId}/ota-rate-plans`, { params })
				.then((resp) => resp.data)
		},
	}
}
